export default __webpack_public_path__ + "static/media/carouselIc.54e30a1f.svg";